import ResourceService from "./resource.service";
import Vue from "vue";

class AllowancesSettingsService extends ResourceService {
  static get resource() {
    return "allowances-settings";
  }

  static updateMobileVisibility(id, mobileVisibility) {
    const url = `${this.resource}/mobile-visibility`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .put(url, { id, mobileVisibility })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default AllowancesSettingsService;